
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landingpage/enterprise",
      function () {
        return require("private-next-pages/landingpage/enterprise/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landingpage/enterprise"])
      });
    }
  